import axios from "../http";
let module = "/sysUser";
function addUserBase(data){
  return axios.post(module +'/addUserBase',data);
}

function selectUserBySearch(data){
  return axios.post(module +'/selectUserBySearch',data);
}

function updateUserWork(data){
  return axios.post(module +'/updateUserWork',data);
}

function updateUserLenable(data){
  return axios.post(module +'/updateUserLenable',data);
}

function deleteUser(data){
  return axios.post(module +'/deleteUser',data);
}

export default {
  addUserBase,
  selectUserBySearch,
  updateUserWork,
  updateUserLenable,
  deleteUser
}



// WEBPACK FOOTER //
// ./src/api/modules/sysUser.js